import React from "react";
import styles from "./Banner.module.scss";
import { F_Open_Sans } from "@/fonts";
import MoonCanvas from "@/elements/canvas/Moon/MoonCanvas";

const Banner = () => {
  return (
    <section
      id="Home"
      className={`${styles.bannerWrapper} ${F_Open_Sans.className}`}
    >
      <div className={styles.textContent}>
        <h3>Hi, my name is</h3>
        <h1>Jasmina Mihajloska</h1>
        <h2>A Front-End developer</h2>
      </div>
      <MoonCanvas />
    </section>
  );
};

export default Banner;
